<template>
    <div class="container">
        <div class="rcv__heading-v1">
             <h1>{{heading}}</h1>
        </div>
        <div class="rcv__start-screen-row">
            <div class="rcv__start-screen-left">
                <img :src="ballotsCountedImage" :alt="altText" width="800" height="379">
            </div>
            <div class="rcv__start-screen-right" v-html="description">
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'RcvV2StartPage',
  props: {
    heading: String,
    description: String,
    ballotsCountedImage: String,
    altText:String
  }
};
</script>


// WEBPACK FOOTER //
// src/components/PracticeRcvv2/Rcv2StartPage.vue